export default __webpack_public_path__ + "static/media/Early fall light.c0339a7d.svg";